import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Stack,
  Typography
} from "@mui/material";
import PhoneIcon from '@mui/icons-material/Phone';
import CallButton from '../controls/CallButton';
import ViberCallButton from '../controls/ViberCallButton';

function CallNumberDialog({
  phoneNumber = "",
}) {
  const [open, setOpen] = React.useState(false);

  const onCancel = () => {
    setOpen(false);
  };

  return (
    <>
    <Stack 
      direction="row" 
      spacing={1}
      sx={{ mb: 2 }}   // adds bottom margin
    >
      <Button
        variant="outlined"
        color="primary"
        size="small"
        startIcon={<PhoneIcon />}
        onClick={() => setOpen(true)}
      >
        Call
      </Button>
    </Stack>
    <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth disableRestoreFocus>
      <DialogTitle>Call {phoneNumber}</DialogTitle>
      <DialogContent>
        <Stack 
          direction="column" 
          spacing={1}
        >
          <CallButton phoneNumber={phoneNumber} label={"Mobile Line"} fullWidth={true} />
          <ViberCallButton phoneNumber={phoneNumber} label={"Viber Call"} fullWidth={true} />
        </Stack>
        
      </DialogContent>
      <DialogActions>
        <>
          <div style={{flex: '1 0 0'}} />
          <Button onClick={onCancel} color="primary">
            Cancel
          </Button>
        </>
      </DialogActions>
    </Dialog>
    </>
  );
}

export default CallNumberDialog;